// utils.js
export const formatBalance = (value, currencyType = null) => {
    if (!value) return currencyType === "USD" ? "$ 0.00" : currencyType === "EUR" ? "€ 0.00" : "0.00"; // Handle empty values
    
    // Remove non-numeric characters (except for decimal point)
    let num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
  
    if (isNaN(num)) return value; // If not a number, return as is
  
    // Format with commas and 2 decimal places
    let formattedValue = num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
    // Return formatted value based on currencyType
    if (currencyType === "USD") return `$ ${formattedValue}`;
    if (currencyType === "EUR") return `€ ${formattedValue}`;
    
    return formattedValue; // If no currencyType, return only the amount
  };
  
export const truncateWalletAddress = (address) => {
  if (!address) return '';
  if (address.length <= 5) return address;
  return `${address.slice(0, 5)}...${address.slice(-4)}`;
};